module.exports = __webpack_public_path__ + "fonts/ralewaymediumitalic.a956617.woff2";